/**
 * @file: 运行前事务处理
 * @author: xiaolong.huang@dmall.com
 */

import UpdateConfig from './updateConfig';
import CreateFlowBorderKeyframes from './borderFlowKeyframes';
import MoveShelfToFront from './moveShelfToFront';
import LayerSort from './layerSort';
import CleanSyStem from './cleanSystem';
import { clearUndefinedCube } from './clearUndefinedCube';
import { sortCabinetChildren } from './cabinetSort';

function runBefore(shelfData: JsonData): void {
    // 清空系统环境
    CleanSyStem();

    // 初始化config
    UpdateConfig(shelfData);

    // 清除不能识别的组件
    clearUndefinedCube(shelfData);

    // 整理货架数据，使货架cube聚合，排在最前面，处理老数据
    MoveShelfToFront(shelfData);

    // 卧柜商品排序
    sortCabinetChildren(shelfData);

    // 层板排序
    LayerSort(shelfData);

    // 流动线速度keyframes创建
    CreateFlowBorderKeyframes();
}

export default runBefore;
